import { render, staticRenderFns } from "./LoginSettings.vue?vue&type=template&id=01917424&scoped=true&"
import script from "./LoginSettings.vue?vue&type=script&lang=js&"
export * from "./LoginSettings.vue?vue&type=script&lang=js&"
import style0 from "./LoginSettings.vue?vue&type=style&index=0&id=01917424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01917424",
  null
  
)

export default component.exports